import {Link, Route, useLocation, useSearch} from "wouter";
import Icon from "../components/Icon.tsx";
import Input from "../components/form/Input.tsx";
import {useState} from "react";
import Button from "../components/form/Button.tsx";
import {getHttpClient, setAccessToken} from "../utils/api.ts";
import {useDocumentTitle, useLocalStorage, useSessionStorage} from "usehooks-ts";
import {useAccessToken} from "../components/hooks/useAccessToken.ts";
import {FiInfo} from "react-icons/fi";
import {FaFacebook} from "react-icons/fa6";

function Auth() {
    return (
        <div className={"container mx-auto"}>
            <div className={"flex flex-col px-2 items-center justify-center"}>
                <div className={"mt-8 max-w-full w-md"}>
                    <div className="flex justify-center">
                        <Icon size={200}/>
                    </div>
                    <div className="card card bg-base-200 shadow border border-base-300 ">
                        <Route path={"/"} component={SignupComponent}/>
                        <Route path={"/signup"} component={SignupComponent}/>
                        <Route path={"/login"} component={Login}/>
                        <Route path={"/forgot-password"} component={ForgotPassword}/>
                        <Route path={"/otp"} component={VerifyOtp}/>
                        <Route path={"/reset-password"} component={ResetPassword}/>
                    </div>
                </div>
                <small className={"d-block text-center mt-2 text-muted"}>By logging in or signing up, you explicitly
                    agree to our<br/><Link className={"link"} to={"~/legal/tos"}>terms and conditions</Link> and <Link
                        className={"link"}
                        to={"~/legal/privacy"}>privacy policy</Link></small>

            </div>
        </div>
    )
}

function MagicLogin() {
    useDocumentTitle("Login")
    const [, navigate] = useLocation()
    const [email, setEmail] = useSessionStorage('login_email', '');
    const [sending, setSending] = useState(false)
    const getOtp = async (e) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation();
        }
        setSending(true)
        await getHttpClient().post('/auth/send_otp',{
            email
        }).then(({data})=>{
            setSending(false)
            if(data.hash) {
                navigate('/otp?hash=' + data.hash)
            }
        })
    }

    return <>
            <form onSubmit={getOtp} className="card-body">
                <h1 className={"text-4xl"}>Login</h1>
                <Input
                    label={"Email address"}
                    placeholder={"Email address"}
                    type={"email"}
                    value={email} onChange={setEmail} />
                <Button loading={sending} onClick={getOtp} className={"btn btn-primary"}>Get OTP</Button>
            </form>
          </>
}
function ForgotPassword() {
    useDocumentTitle("Forgot Password")
    const [, navigate] = useLocation()
    const [email, setEmail] = useSessionStorage('login_email', '');
    const [sending, setSending] = useState(false)
    const getOtp = async (e) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation();
        }
        setSending(true)
        await getHttpClient().post('/auth/forgot-password',{
            email
        }).then(({data})=>{
            setSending(false)
            if(data.hash) {
                navigate('/reset-password?hash=' + data.hash)
            }
        })
    }

    return <>
        <form onSubmit={getOtp} className="card-body">
            <h1 className={"text-4xl mb-2"}>Forgot password</h1>
            <Input
                label={"Email address"}
                placeholder={"Email address"}
                type={"email"}
                value={email} onChange={setEmail}/>
            <p className={"opacity-50 text-center"}>We will send you a password reset code on your email. Enter the code in the next step to reset your password</p>
            <Button loading={sending} onClick={getOtp} className={"btn btn-primary"}>Get OTP</Button>
        </form>
    </>
}

function Login() {
    useDocumentTitle("Login")
    const [password, setPassword] = useState( '');
    const [email, setEmail] = useLocalStorage('login_email', '');
    const [sending, setSending] = useState(false)
    const [error, setError] = useState('')
    const login = async (e) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation();
        }
        setSending(true)
        await getHttpClient().post('/auth/login',{
            email,
            password,
        }).then(({data})=>{
            setSending(false)
            if(data.access_token){
                setAccessToken(data.access_token);
                window.location.assign("/")
            }else{
                setError(data.error)
            }
        })
    }

    return <>
        <form onSubmit={login} className="card-body">
            <h1 className={"text-4xl mb-3"}>Login</h1>
            <div className="mb-2">
                <Input
                    label={"Email address"}
                    placeholder={"Email address"}
                    type={"email"}
                    name={"email"}
                    value={email} onChange={setEmail}/>
            </div>
            <div className="mb-2">
                <Input
                    label={"Password"}
                    name={"password"}
                    type={"password"}
                    placeholder={"Password"}
                    autoComplete={"new-password"}
                    value={password} onChange={setPassword}/>
            </div>
            {
                error ? <div className={"alert alert-error"}><FiInfo />{error}</div> : null
            }
            <Button loading={sending} onClick={login} className={"btn btn-primary"}>LOGIN</Button>
            <LoginWithFacebook />
            <p className={"text-center mt-6"}>Don't have an account? <Link to={"/signup"} className={"link"}>Sign up</Link>
            </p>
            <p className={"text-center mt-6"}>
                <Link to={"/forgot-password"} className={"link"}>
                    Forgot password ?
                </Link>
            </p>
        </form>
    </>
}


function SignupComponent() {
    useDocumentTitle("Sign up")
    const [name, setName] = useState('');
    const [email, setEmail] = useLocalStorage('login_email', '');
    const [password, setPassword] = useState('');
    const [sending, setSending] = useState(false)
    const [error, setError] = useState('')
    const signup = async (e) => {
        if (e) {
            e.preventDefault()
            e.stopPropagation();
        }
        setSending(true)
        await getHttpClient().post('/auth/signup',{
            email,
            name, password,
        }).then(({data})=>{
            setSending(false)
            if(data.access_token){
                setAccessToken(data.access_token);
                window.location.assign("/")
            }else{
                setError(data.error)
            }
        })
    }
    return (
        <form onSubmit={signup} className="card-body">
            <h1 className={"text-4xl mb-2"}>Sign up</h1>
            <Input
                name={"name"}
                label={"Your name"}
                placeholder={"eg. John Doe"}
                type={"text"}
                autoComplete={"given-name"}
                value={name} onChange={setName}/>
            <div className="my-2">
                <Input
                    name={"email"}
                    label={"Email address"}
                    placeholder={"Email address"}
                    type={"email"}
                    autoComplete={"email"}
                    value={email} onChange={setEmail}/>
            </div>
            <div className="mb-2">
                <Input
                    label={"Password"}
                    name={"password"}
                    placeholder={"Password"}
                    type={"password"}
                    autoComplete={"new-password"}
                    value={password} onChange={setPassword}/>
            </div>
            {
                error ? <div className={"alert alert-error"}><FiInfo />{error}</div> : null
            }
            <Button loading={sending} onClick={signup} className={"btn btn-primary"}>SIGN UP</Button>
            <LoginWithFacebook />
            <p className={"text-center mt-6"}>Already have an account? <Link to={"/login"} className={"link"}>Login</Link></p>
        </form>
    )

}


function VerifyOtp() {
    useDocumentTitle("Verify OTP")
    const {setAccessToken} = useAccessToken();
    const [, navigate] = useLocation()
    const [error, setError] = useState('')
    const search = useSearch()
    const [otp, setOtp] = useState('');
    const [sending, setSending] = useState(false)
    const verifyOtp = async (e) => {
        setSending(true)
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const params = new URLSearchParams(search);
        await getHttpClient().post('/auth/verify_otp',{
            hash: params.get('hash'),
            otp
        }).then(({data})=>{
            setSending(false)
            if(data.access_token){
                setAccessToken(data.access_token);
                window.location.assign("/")
                // navigate('~/',{
                //     replace:true
                // })
            }else if(data.error){
                setError(data.error)
            }
        })
    }

    return <>
        <form onSubmit={verifyOtp}>
            <div className="card-body">
                <h1 className={"text-4xl mb-1"}>Verify OTP</h1>
                <p className={"mb-2"}>Enter the OTP that you received on your email below</p>
                <div className="mb-2">
                    <Input
                        label={"OTP"}
                        placeholder={"123456"}
                        type={"number"}
                        maxLength={6}
                        value={otp} onChange={setOtp} />
                </div>
                {
                    error ? <div className={"alert alert-error"}><FiInfo />{error}</div> : null
                }
                <Button disabled={!otp || String(otp).length < 6} loading={sending} onClick={verifyOtp} className={"btn btn-primary"}>Verify OTP</Button>
            </div>
        </form>
    </>
}
function ResetPassword() {
    useDocumentTitle("Reset Password")
    const {setAccessToken} = useAccessToken();
    const search = useSearch()
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('')
    const [otp, setOtp] = useState('');
    const [sending, setSending] = useState(false)
    const verifyOtp = async (e) => {
        setSending(true)
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const params = new URLSearchParams(search);
        await getHttpClient().post('/auth/reset-password',{
            hash: params.get('hash'),
            otp,
            password: newPassword,
        }).then(({data})=>{
            setSending(false)
            if(data.access_token){
                setAccessToken(data.access_token);
                window.location.assign("/")
            }else if(data.error){
                setError(data.error)
            }
        })
    }

    return <>
        <form onSubmit={verifyOtp}>
            <div className="card-body">
                <h1 className={"text-4xl mb-1"}>Reset password</h1>
                <p className={"mb-2"}>Enter the OTP that you received on your email below</p>
                <div className="mb-2">

                    <Input
                        label={"OTP"}
                        placeholder={"123456"}
                        type={"number"}
                        maxLength={6}
                        value={otp} onChange={setOtp} />
                </div>
                <div className="mb-2">
                    <Input
                        label={"New password"}
                        placeholder={"New password"}
                        type={"password"}
                        name={"password"}
                        autoComplete={"new-password"}
                        value={newPassword} onChange={setNewPassword} />

                </div>
                {
                    error ? <div className={"alert alert-error"}><FiInfo />{error}</div> : null
                }
                <Button disabled={!otp || String(otp).length < 6} loading={sending} onClick={verifyOtp} className={"btn btn-primary"}>Update password</Button>
            </div>
        </form>
    </>
}


function LoginWithFacebook() {
    return <a
        href={`https://api.timelyturtle.com/auth/facebook?platform=web&${import.meta.env.DEV ? '?mode=dev' : ''}`}
        // onClick={handleFacebookLogin}
        className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-2.5 px-4 rounded-lg transition duration-300 ease-in-out"
    >
        <FaFacebook size={20} />
        <span>Continue with Facebook</span>
    </a>

}

export default Auth;
